<template>
  <div>
    <el-container style="width:100vw;height: 100vh;overflow: hidden;">
      <el-aside width="auto" class="mobile">
        <common-aside />
      </el-aside>

      <el-container>
        <el-header>
          <common-header />
        </el-header>
        <el-main class="main-content">
          <common-tag />
          <div class="page-body">
            <router-view />
          </div>
        </el-main>
      </el-container>
    </el-container>

  </div>
</template>

<script>
import CommonAside from "@/components/CommonAside"
import CommonHeader from "@/components/CommonHeader"
import CommonTag from "@/components/CommonTag"
import router from '@/router'
import { isMobile } from '@/utils/device'

window.onload = function () {
  let lastTime = localStorage.getItem("lastTime");
  const interval = 10 * 1000;
  // 如果没有上一次离开的时间或者时间间隔大于3s，就清除token
  if (!lastTime || new Date().getTime() - lastTime > interval) {
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('username')
    localStorage.removeItem('proxy_id')
    router.push({ name: 'login' })
  } else {
    // console.log("时间过短不清除token")
  }
};
window.onunload = function () {
  localStorage.setItem("lastTime", new Date().getTime());
  // console.log("onunload")
};

// const beforeunloadHandler = () => {
//   localStorage.setItem("lastTime", new Date().getTime());
// }
//
// const unloadHandler = () => {
//   var gap_time = new Date().getTime() - localStorage.getItem("lastTime");
//   localStorage.setItem("time", gap_time);
//
//   //判断是窗口关闭还是刷新 毫秒数判断 网上大部分写的是5
//   if (gap_time < 5) {
//     localStorage.removeItem('token')
//     localStorage.removeItem('userInfo')
//     localStorage.removeItem('username')
//     localStorage.removeItem('proxy_id')
//     this.$router.push({ name: 'login' })
//   } else {
//
//   }
// }
export default {
  name: "Main",
  data() {
    return {
      isMobile:false,
    };
  },
  mounted() {
    // 监听浏览器关闭
    window.addEventListener("beforeunload", () => beforeunloadHandler());
    window.addEventListener("unload", () => unloadHandler());
    this.checkDevice()
  },
  components: {
    CommonAside,
    CommonHeader,
    CommonTag,
  },
  methods:{
    checkDevice() {
      this.isMobile = isMobile()
      // 进入页面时先展开侧边栏
      this.$store.commit('setCollapse', false)
      if (this.isMobile) {
        // 移动端：3 秒后自动收起
        setTimeout(() => {
          this.$store.commit('setCollapse', true)
        }, 3000)
      }
    }
  }
}
</script>

<style lang="less">
.el-header {
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .18);
  position: relative;
  z-index: 100;
}

.el-container.is-vertical {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.main-content {
  background-color: #f9fafb;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
}

.page-body {
  padding: 20px;
}

.mobile {
  .el-menu--collapse {
    width: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Main.vue